import React from "react";
import { Modal, Button, Box } from "@amzn/awsui-components-react-v3";
import { Redirect } from "react-router-dom";

interface ErrorState {
  hasError: boolean;
  isDismiss: boolean;
  message?: string;
}

interface ErrorBoundaryProps {
  children: React.ReactNode;
}

class ErrorBoundary extends React.Component<ErrorBoundaryProps, ErrorState> {
  public constructor(properties: ErrorBoundaryProps) {
    super(properties);
    this.state = { hasError: false, isDismiss: false };
  }

  public static getDerivedStateFromError(error: Error): ErrorState {
    return { hasError: true, isDismiss: false, message: error.message };
  }

  public onDismiss = (): void => {
    this.setState({ hasError: true, isDismiss: true });
  };

  public render(): React.ReactNode {
    const { hasError, isDismiss, message } = this.state;
    if (hasError) {
      return (
        (isDismiss && <Redirect to="/" />) || (
          <Modal
            visible
            header="An Error Has Occurred"
            onDismiss={this.onDismiss}
            size="large"
            footer={
              <Box float="right">
                <Button variant="primary" onClick={this.onDismiss}>
                  Dismiss
                </Button>
              </Box>
            }
          >
            {<div>{message}</div>}
          </Modal>
        )
      );
    }
    const { children } = this.props;
    return children;
  }
}

export default ErrorBoundary;
